import { FormControlLabel, Checkbox, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface ICheckBoxProps {
  name: string;
  label: string;
}

export function CheckBox(props: ICheckBoxProps) {
  const { name, label } = props;
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={<Checkbox {...field} color="primary" />}
          label={
            <Typography whiteSpace="pre-wrap" fontWeight={'500'}>
              {label}
            </Typography>
          }
          labelPlacement="start"
          checked={field.value}
        />
      )}
    />
  );
}
